import OrderList from 'features/order-list';

const OrdersPage = () => {
  return <OrderList />;
};
export default OrdersPage;
